<template>
  <el-dialog
    :title="'【' + modelParam.task_id + '】' + modelParam.describe"
    center
    class="devOps-modelEight"
    :visible.sync="dialogVisible"
    width="80%"
    top="10px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="160px">
      <el-form-item label="UAT验证描述" prop="uat_content">
        <Editor
          :content="form.uat_content"
          @contentData="changeEditContent"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="UAT验证地址" prop="uat_url">
        <el-input placeholder="请输入" v-model="form.uat_url"></el-input>
      </el-form-item>
      <el-form-item label="计划发布时间">
        <el-date-picker
          style="width: 100%"
          v-model="form.pdt"
          type="datetime"
          placeholder="默认ODOO为当天12:00，其他模块为当天18:00"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          :disabled="runLoading"
          type="warning"
          @click="onSubmit('run')"
          >提交<i v-show="runLoading" class="el-icon-loading"></i
        ></el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi"
          >查看历史</el-button
        >
        <el-button type="warning" @click="handleClose">返回</el-button>
      </el-form-item>
    </el-form>
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
} from "@/server/tops/devOps";
import { TableOne } from "../table/index";
import { Editor } from "@/components/index.js";
export default {
  components: { TableOne, Editor },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () {};
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        uat_content: ''
      },
      rules: {
        uat_content: [
          { required: true, message: "请输入UAT验证描述", trigger: "blur" },
        ],
      },
      message: "",
      runLoading: false,
      tableData: [],
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "当天12:00",
            onClick: (picker) => {
              const day = this.$moment(new Date()).format("YYYY-MM-DD");
              const date = new Date(day + " 12:00:00");
              picker.$emit("pick", date);
            },
          },
          {
            text: "当天18:00",
            onClick: (picker) => {
              const day = this.$moment(new Date()).format("YYYY-MM-DD");
              const date = new Date(day + " 18:00:00");
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  async mounted() {
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  methods: {
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = { ...this.form, ...ret.data };
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    changeEditContent(val) {
      this.form.uat_content = val;
    },
    // 提交
    async onSubmit(action) {
      action === "run" && (await this.queryActionRunSubmit("run"));
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;

          const { uat_content = "", uat_url = "", pdt = "" } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            uat_content,
            uat_url,
            pdt: pdt ? this.$moment(pdt).format("YYYY-MM-DD HH:mm:ss") : "",
          };
          this.runLoading = true;
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            this.message = JSON.stringify(ret.data || "", null, 2);
            let info = ret?.data?.output?.uat[0] || {};
            this.$notify({
              message: info.msg || "",
              type: info.code === 0 ? "success" : "error",
            });
          } catch (error) {
            this.$notify({
              message: error || "操作失败",
              type: "error",
            });
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelEight {
  .el-input__inner {
    font-size: 14px !important;
  }
  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }
  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }
  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }
  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;
    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>